import { render, staticRenderFns } from "./HeaderBreadcrumb.vue?vue&type=template&id=24d2a42a"
import script from "./HeaderBreadcrumb.vue?vue&type=script&lang=js"
export * from "./HeaderBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./HeaderBreadcrumb.vue?vue&type=style&index=0&id=24d2a42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports